/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PhysicalStatus = {
    NotSpecified: 'NotSpecified',
    ClosedDown: 'ClosedDown',
    New: 'New',
    Connected: 'Connected',
    Disconnected: 'Disconnected',
} as const;
export type PhysicalStatus = typeof PhysicalStatus[keyof typeof PhysicalStatus];

